import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import formSlice from "./slices/formSlice";
import submissionSlice from "./slices/submissionSlice";
import masterSlice from "./slices/masterSlice";
import usersSlice from "./slices/usersSlice";
import newLoomReducer from "./slices/newLoomSlice";
import cfcReducer from "./slices/cfcSlice";
import oldConventionalReducer from "./slices/oldConventionalSlice";
import airJetLoomReducer from "./slices/airJetLoomSlice";
import submissionFilterReducer from "./slices/submissionFilterSlice.js";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    forms: formSlice,
    submissions: submissionSlice,
    master: masterSlice,
    users: usersSlice,
    newLoom: newLoomReducer,
    cfc: cfcReducer,
    oldConventional: oldConventionalReducer,
    airJetLoom: airJetLoomReducer,
    submissionFilter: submissionFilterReducer,
  },
});
